// extracted by mini-css-extract-plugin
export default {"wrapper":"No-z","response":"Oo-z","error":"Po-z","disabled":"Qo-z","buttons":"Ro-z","feedbackQuestionSection":"So-z","yesNoWrapper":"To-z"};